// extracted by mini-css-extract-plugin
export var accessibility_message = "a11yMessage-module--accessibility_message--2a0d1";
export var accessibilty_message = "a11yMessage-module--accessibilty_message--63d48";
export var message = "a11yMessage-module--message--b7a37";